<!-- Barra de progreso de fuerza de contraseña -->
<div class="strength mt-2">
  <ul class="strengthBar">
    <li class="point" [style.background-color]="barColors[0]"></li>
    <li class="point" [style.background-color]="barColors[1]"></li>
    <li class="point" [style.background-color]="barColors[2]"></li>
    <li class="point" [style.background-color]="barColors[3]"></li>
  </ul>
  <p class="text-center mb-0" [style.color]="messageColor">{{ message | translate }}</p>
</div>


<div *ngIf="isFocused" @fadeInOut class="password-criteria mt-2">
  <p [ngClass]="{ 'text-success': passwordCriteria.length, 'text-danger': !passwordCriteria.length }">
    <span *ngIf="passwordCriteria.length; else errorIcon">✔️</span>
    <ng-template #errorIcon>❌</ng-template>
    {{'Al menos' | translate }} {{minPasswordLength}} {{'caracteres de largo' | translate }}
  </p>
  <p [ngClass]="{ 'text-success': passwordCriteria.lowercase, 'text-danger': !passwordCriteria.lowercase }">
    <span *ngIf="passwordCriteria.lowercase; else errorIcon">✔️</span>
    <ng-template #errorIcon>❌</ng-template>
    {{ 'Al menos una letra minúscula' | translate }}
  </p>
  <p [ngClass]="{ 'text-success': passwordCriteria.uppercase, 'text-danger': !passwordCriteria.uppercase }">
    <span *ngIf="passwordCriteria.uppercase; else errorIcon">✔️</span>
    <ng-template #errorIcon>❌</ng-template>
    {{'Al menos una letra mayúscula' | translate }}
  </p>
  <p [ngClass]="{ 'text-success': passwordCriteria.number, 'text-danger': !passwordCriteria.number }">
    <span *ngIf="passwordCriteria.number; else errorIcon">✔️</span>
    <ng-template #errorIcon>❌</ng-template>
    {{'Al menos un número' | translate }}
  </p>
  <p [ngClass]="{ 'text-success': passwordCriteria.specialChar, 'text-danger': !passwordCriteria.specialChar }">
    <span *ngIf="passwordCriteria.specialChar; else errorIcon">✔️</span>
    <ng-template #errorIcon>❌</ng-template>
    {{'Al menos un carácter especial' | translate }}
  </p>
</div>
